"use client"
import Link from "next/link"
import * as LucideIcons from "lucide-react"
import { Image as LucideImage } from "lucide-react"

const LUCIDE_ICON_WHITELIST = [
  'Camera', 'Heart', 'Users', 'Image', 'Sparkles', 'Eye', 'Calendar', 'Instagram', 'Menu', 'ChevronDown', 'Phone', 'Mail', 'MapPin',
]
function getLucideIcon(iconName: string): React.ComponentType<{ className?: string }> {
  if (LUCIDE_ICON_WHITELIST.includes(iconName)) {
    const Icon = LucideIcons[iconName as keyof typeof LucideIcons]
    if (
      typeof Icon === 'function' &&
      (typeof (Icon as any).displayName === 'string' || typeof (Icon as any).render === 'function')
    ) {
      return Icon as React.ComponentType<{ className?: string }>
    }
  }
  return LucideImage
}

export default function FooterGalleryLinks({ galleries }: { galleries: any[] }) {
  return (
    <ul className="space-y-2">
      {galleries.map((item) => {
        const Icon = getLucideIcon(item.fields.icon)
        return (
          <li key={item.fields.slug}>
            <Link
              href={`/galleries/${item.fields.slug}`}
              className="text-gray-600 hover:text-purple-600 transition-colors text-sm flex items-center"
            >
              <Icon className="w-4 h-4 mr-2 text-purple-600" />
              {item.fields.galleryName}
            </Link>
          </li>
        )
      })}
    </ul>
  )
} 